import Loader from "react-loader-spinner";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import BihamtaTable from "../Components/BihamtaTable";
import { CheckLg, DashCircle, PencilFill, PlusSquare, Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form"
import { deleteContact, addEditContact, searchContacts, getContactGroupList } from "../store/api/ContactsAPI";
import { setErrorDialog } from "../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

const Contacts = () => {
    const dispatch = useDispatch();
    const [groups, setGroups] = useState(null);
    const [dataList, setDataList] = useState({ Data: [] });
    const { register, errors, handleSubmit } = useForm();
    const searchData = useRef({});
    const currentGroup = useRef({});
    const [submitError, setSubmitError] = useState(null);
    const [currentContact, setCurrentContact] = useState(null);
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نام مخاطب", colName: "Name", showInMobile: true },
        { colTitle: "شماره همراه", colName: "Mobile", showInMobile: true },
        { colTitle: "تلفن منزل", colName: "Phone_Home", showInMobile: true },
        { colTitle: "تلفن محل کار", colName: "Phone_Work" },
        { colTitle: "نشانی محل سکونت", colName: "Address_Home" },
        { colTitle: "نشانی محل کار", colName: "Address_Work" }
    ]
    const tableButtons = [
        { type: "delete", title: "حذف مخاطب", onclick: deleteC },
        { type: "common", icon: <PencilFill color="orange" className="rowBtn" size={18} />, title: "ویرایش مخاطب", onclick: prepareForEdit }
    ]
    function prepareForAdd() {
        setCurrentContact({ ID: 0 });
    }
    function prepareForEdit(row) {
        delete row.e;
        setCurrentContact({ ...row });
    }
    function deleteC(row) {
        const onDelete = (res) => {
            if (res.Data) {
                dataList.Data = dataList.Data.filter(r => Number(r.ID) !== Number(row.ID));
                setDataList({ ...dataList });
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف مخاطب");
            }
        }
        deleteContact(row.ID, onDelete);
    }
    function cancelData() {
        setSubmitError(null);
        setCurrentContact(null);
    }
    function submitData(data) {
        setSubmitError(null);
        data.GroupName = currentGroup.current?.Group;
        data.GroupID = currentGroup.current?.ID;
        const onAddEdit = (res) => {
            if (res.Data) {
                if (Number(data.ID) > 0) {
                    const c = dataList.Data.find(c => Number(c.ID) === Number(data.ID));
                    Object.assign(c, data);
                    setDataList({ ...dataList });
                }
                else {
                    data.ID = res.Data;
                    dataList.Data.push(data);
                    setDataList({ ...dataList });
                }
                setErrorDialog(dispatch, "success", "ثبت اطلاعات مخاطب");
                setCurrentContact(null);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت اطلاعات مخاطب");
            }
        }
        addEditContact(data, onAddEdit);
    }
    function search(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        searchData.current.GroupID = currentGroup.current.ID;
        searchContacts(searchData.current, setDataList);
    }
    function onGroupChange(e) {
        const list = e.target.getAttribute('list');
        const options = document.querySelectorAll('#' + list + ' option');
        currentGroup.current.Group = e.target.value;
        currentGroup.current.ID = null;
        if (e.target.value !== "") {
            for (let i = 0; i < options.length; i++) {
                var option = options[i];
                if (option.innerText === e.target.value) {
                    currentGroup.current.ID = option.getAttribute('data-value');
                    break;
                }
            }
        }
    }
    useEffect(() => {
        getContactGroupList(setGroups);
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faIdCard} size="lg" />&nbsp;
                    مدیریت مخاطبین
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <Col md={3} className="form-group">
                        <label>گروه مخاطب</label>
                        {
                            !groups?.Data &&
                            <div className="form-control">
                                <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block" }} />&nbsp;
                                در حال بارگذاری لیست
                            </div>
                        }
                        {
                            groups?.Data &&
                            <Fragment>
                                <Form.Control list="contactGroups" autoComplete="on" onChange={onGroupChange} />
                                <datalist id="contactGroups">
                                    {groups.Data.map((grp, i) => <option data-value={grp.ID} key={i}>{grp.Group}</option>)}
                                </datalist>
                            </Fragment>
                            // <select className="form-control" onChange={e => currentGroup.current.GroupID = e.target.value}>
                            //     <option value="">انتخاب کنید</option>
                            //     {
                            //         groups.Data.map((grp, i) => <option value={grp.ID} key={i}>{grp.Group}</option>)
                            //     }
                            // </select>
                        }
                    </Col>
                    {currentContact &&
                        <form onSubmit={handleSubmit(submitData)}>
                            <input type="hidden" defaultValue={currentContact.ID ?? ""} name="ID" ref={register({})} />
                            <Row className="rowBorder mt-1">
                                <Col md={2} className="form-group">
                                    <label>نام: </label>
                                    <Form.Control name="Name" ref={register({ required: true })} defaultValue={currentContact.Name} />
                                    {errors.Name && <small className="errors">نام الزامی است</small>}
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>تلفن منزل: </label>
                                    <Form.Control name="Phone_Home" ref={register({})} defaultValue={currentContact.Phone_Home ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>شماره همراه: </label>
                                    <Form.Control name="Mobile" ref={register({ required: true })} defaultValue={currentContact.Mobile ?? ""} />
                                    {errors.Mobile && <small className="errors">شماره همراه الزامی است</small>}
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>نشانی خانه: </label>
                                    <Form.Control name="Address_Home" ref={register({})} defaultValue={currentContact.Address_Home ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>کد پستی منزل: </label>
                                    <Form.Control name="PostalCode_Home" ref={register({})} defaultValue={currentContact.PostalCode_Home ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>نلفن محل کار: </label>
                                    <Form.Control name="Phone_Work" ref={register({})} defaultValue={currentContact.Phone_Work ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>فکس منزل: </label>
                                    <Form.Control name="Fax_Home" ref={register({})} defaultValue={currentContact.Fax_Home ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>نشانی محل کار: </label>
                                    <Form.Control name="Address_Work" ref={register({})} defaultValue={currentContact.Address_Work ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>کد پستی محل کار: </label>
                                    <Form.Control name="PostalCode_Work" ref={register({})} defaultValue={currentContact.PostalCode_Work ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>فکس محل کار: </label>
                                    <Form.Control name="Fax_Work" ref={register({})} defaultValue={currentContact.Fax_Work ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>کد ملی: </label>
                                    <Form.Control name="NationalCode" ref={register({})} defaultValue={currentContact.NationalCode ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>Email: </label>
                                    <Form.Control name="Email" ref={register({})} defaultValue={currentContact.Email ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>عنوان شغلی: </label>
                                    <Form.Control name="JobTitle" ref={register({})} defaultValue={currentContact.JobTitle ?? ""} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>توضیحات: </label>
                                    <Form.Control name="Description" ref={register({})} defaultValue={currentContact.Description ?? ""} />
                                </Col>
                                <div className="mt-1">
                                    <Button className="group-Btn" variant="success" type="submit">
                                        {
                                            Number(currentContact.ID) === 0 &&
                                            <Fragment>
                                                <CheckLg size={16} />&nbsp; ثبت اطلاعات
                                            </Fragment>
                                        }
                                        {
                                            Number(currentContact.ID) > 0 &&
                                            <Fragment>
                                                <PencilFill size={17} />&nbsp; ویرایش اطلاعات
                                            </Fragment>
                                        }
                                    </Button>
                                    <Button className="group-Btn" variant="danger" onClick={cancelData}><DashCircle size={17} />&nbsp; انصراف</Button>
                                </div>
                            </Row>
                        </form>
                    }
                    {
                        !currentContact &&
                        <Row className="rowBorder mt-1">
                            <Col md={2} className="form-group">
                                <Form.Control placeholder="نام مخاطب" onChange={e => searchData.current.Name = e.target.value} defaultValue={searchData.current.Name ?? ""} onKeyDown={search} />
                            </Col>
                            <Col md={2} className="form-group">
                                <Form.Control placeholder="شماره همراه" onChange={e => searchData.current.Mobile = e.target.value} defaultValue={searchData.current.Mobile ?? ""} onKeyDown={search} />
                            </Col>
                            <Col md={2} className="form-group">
                                <Form.Control placeholder="تلفن مخاطب" onChange={e => searchData.current.Phone = e.target.value} defaultValue={searchData.current.Phone ?? ""} onKeyDown={search} />
                            </Col>
                            <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                                <Button className="group-Btn-large" onClick={search}>
                                    <Search size={17} />&nbsp; جستجوی مخاطب
                                </Button>
                            </Col>
                        </Row>
                    }
                    {!currentContact &&
                        <PlusSquare className="mt-1 hoverIcon" color="blue" size={25} onClick={prepareForAdd} style={{ cursor: "pointer" }} />}
                    <BihamtaTable columns={tableCols} rowButtons={tableButtons} dataList={dataList} fixedHeightTable className="mt-0" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default Contacts;